import { useMediaQuery } from '@mui/material';
import newMemberInHomePage from '../../assets/newMemberInHomePage.png'
import { useCountdown } from "../../hooks/useCountdown";
import {useMatomoTrackingPoint} from "../../hooks/useMatomoTrackingPoint";
import {useDispatch} from "react-redux";
import {setOpenDropDialogChange} from "../../store/memberSlice";
import {AppDispatch} from "../../store";
import {memberInfoProps} from "../../types/member.type";

interface NewUserCountdownProps {
    boardId: string | null;
    memberInfo: memberInfoProps | null;
}

export default function NewUserCountdown({ boardId, memberInfo }: NewUserCountdownProps) {
    const isMobile = useMediaQuery('(max-width: 768px)');
    const { trackWaterdropPackagePopupShow } = useMatomoTrackingPoint();
    const dispatch: AppDispatch = useDispatch();

    const countdown = useCountdown({
        startTime: memberInfo?.createAt,
        durationDays: 3,
        enabled: !!memberInfo?.createAt
    });

    if (!countdown || memberInfo?.isBuyLimitDay) return null;

    return (
        <div className='homePageNewUser' onClick={() => {
            const page_id = window.location.href;
            trackWaterdropPackagePopupShow({
                package_show_from: 'new_user_countdown',
                page_id
            });
            dispatch(setOpenDropDialogChange(true))
        }}>
            <img src={newMemberInHomePage} alt='' style={{height: 40, width: 'auto', marginRight: '-8px', zIndex: 1}} />
            <div className={`homePageNewUserContent ${countdown.days ? 'homePageNewUserContent--short' : 'homePageNewUserContent--long'}`}>
                <div className='countDownHomePage'>
                    <>距结束 <span>{String(countdown.days).padStart(2, '0')}</span>天
                        {
                            !countdown.days && <>
                                <span>{String(countdown.hours).padStart(2, '0')}</span>:<span>{String(countdown.minutes).padStart(2, '0')}</span>:<span>{String(countdown.seconds).padStart(2, '0')}</span></>
                        }
                    </>
                </div>
            </div>
        </div>
    );
}
